/**
 * Created by Ning Jiang on 12/3/2019.
 */

import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {DWBackground} from "../../background/DWBackground";
import {DeadwoodGameConfig} from "../../DeadwoodGameConfig";
import {Power2, Timeline, TimelineLite, TweenLite} from "gsap";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {Deadwood} from "../../Deadwood";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";

export class WinNumberText extends PIXI.Container {
    private _maxWayWidth:number = 220;

    constructor(winAmount:number, multiplier:number, way:number) {
        super();
        // winAmount = 100000000;
        // way = 11216;
        // winAmount = 10.22;
        // way = 122;
        const winNumberContainer = new PIXI.Container();
        this.addChild(winNumberContainer);
        winNumberContainer.y = -5;

        let winTotalWidth = 0;
        const winNumber = new PIXI.BitmapText(`${Deadwood.api.currency.formatValue(winAmount)}`, {
            fontName : "DeadwoodCountUpFont",
            fontSize : 32,
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
        winNumber.letterSpacing = -10;
        (<PIXI.Point>winNumber.anchor).set(0, 0.5);
        winNumberContainer.addChild(winNumber);
        winNumber.updateTransform();
        winTotalWidth += winNumber.textWidth;

        if(multiplier > 1) {
            const multiplierText = new PIXI.BitmapText(`x${multiplier}`, {
                fontName : "TotalMultipliers",
                fontSize : 4,
                tint : 0xffffff
            });
            (<PIXI.Point>multiplierText.anchor).set(1, 0.5);
            multiplierText.letterSpacing = -20;
            winNumberContainer.addChild(multiplierText);
            multiplierText.updateTransform();
            winTotalWidth += multiplierText.textWidth;
            multiplierText.x = winTotalWidth * 0.5;
        }
        winNumber.x = -winTotalWidth * 0.5;

        if(winTotalWidth > this._maxWayWidth) {
            const winScale = MathHelper.roundToDecimals(this._maxWayWidth / winTotalWidth, 2);
            winNumberContainer.scale.set(winScale);
        }

        const waysContainer = new PIXI.Container();
        this.addChild(waysContainer);
        waysContainer.y = 20;

        // way
        const waysWonNumber = new PIXI.BitmapText(way.toString(), {
            fontName : "NumbersWaysWon",
            fontSize : 4,
            tint : 0xffffff
        });
        (<PIXI.Point>waysWonNumber.anchor).set(0, 0.5);
        waysWonNumber.letterSpacing = -10;
        waysContainer.addChild(waysWonNumber);

        const textureName:string = way === 1 ? 'winways/WayText' : 'winways/WaysText';
        const waysWonText = new PIXI.Sprite(GameResources.getTextures(textureName)[0]);
        waysWonText.anchor.set(1, 0.4);
        waysWonText.scale.set(0.3);
        waysContainer.addChild(waysWonText);

        waysWonNumber.updateTransform();
        const waysTotalWidth:number = waysWonNumber.width + waysWonText.width;
        waysWonNumber.x = -waysTotalWidth / 2;
        waysWonText.x = waysTotalWidth / 2;
        if(waysTotalWidth > this._maxWayWidth) {
            const waysScale = MathHelper.roundToDecimals(this._maxWayWidth / waysTotalWidth, 2);
            waysContainer.scale.set(waysScale);
        }
    }
}

class IndividualWinGlow extends PIXI.Container {

    static GLOW_ANIMATION_NAME:string = "individualWin_symGlow";

    private _glowSprite:PIXI.Sprite;
    private _glowSpine:PIXI.spine.Spine;

    public get glowSpine():PIXI.spine.Spine {
        return this._glowSpine;
    }

    constructor() {
        super();

        this._glowSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("individualWin_symGlow"));
        this._glowSpine.autoUpdate = true;

        this._glowSprite = new PIXI.Sprite();
        this._glowSprite.anchor.set(0.5);
        this._glowSprite.addChild(this._glowSpine);

        this.addChild(this._glowSprite);
    }
}

export class DeadwoodIndividualWPView extends BaseView {

    private _winGlowContainer:PIXI.Container;
    private _winGlowPool:IndividualWinGlow[] = [];

    private _wildGlowContainer:PIXI.Container;
    private _wildGlowPool:PIXI.Sprite[] = [];

    private _layer:ScalableLayer;

    private _winNumberText:WinNumberText | null;
    private _winNumberTl:TweenLite | null;

    constructor() {
        super();
    }

    protected initAnimations():void {
        this._layer = StageManager.getLayer(DeadwoodGameConfig.instance.LAYERS.SYMBOL_WIN_GLOW.name);
        this._winGlowContainer = new PIXI.Container();
        this._layer.addChild(this._winGlowContainer);

        this._wildGlowContainer = new PIXI.Container();
        StageManager.getLayer(DeadwoodGameConfig.instance.LAYERS.SYMBOLS_SHOT.name).addChild(this._wildGlowContainer);
    }

    public addSymbolGlowToTimeline(betWayWinData:IBetWayWinData, timeline:Timeline, startTime:number, position:[number, number], isWild:boolean, endAlpha:number, showWinText:boolean):void {
        const overlayTimeline:TimelineLite = new TimelineLite();

        if(isWild) {
            const wildGlow:PIXI.Sprite = this.getWildGlow();
            wildGlow.position.set(position[0], position[1] + GameConfig.instance.SYMBOL_HEIGHT * 0.5);
            this._wildGlowContainer.addChild(wildGlow);

            overlayTimeline.add(TweenLite.to(wildGlow, 0.3, {alpha : endAlpha}));
            overlayTimeline.add(TweenLite.to(wildGlow, 0.5, {alpha : 0, ease : Power2.easeIn}), "+=0.6");
            overlayTimeline.add(() => this.recycleWildGlow(wildGlow));
        } else {
            const winGlow:IndividualWinGlow = this.getWinGlow();
            winGlow.position.set(position[0], position[1]);
            this._winGlowContainer.addChild(winGlow);

            overlayTimeline.add([
                TweenLite.to(winGlow, 0.2, {alpha : endAlpha}),
                new SpineTween(winGlow.glowSpine, 0, IndividualWinGlow.GLOW_ANIMATION_NAME),
            ]);
            overlayTimeline.add(() => this.recycleWinGlow(winGlow));
        }
        timeline.add(overlayTimeline, startTime);
        if(showWinText) {
            timeline.add(() => {
                this.showWinText(betWayWinData, position);
            }, startTime);
        }
    }

    private getWildGlow():PIXI.Sprite {
        const wildGlow:PIXI.Sprite = this._wildGlowPool.length === 0 ? this.createNewWildGlow() : this._wildGlowPool.pop()!;
        wildGlow.alpha = 0;
        return wildGlow;
    }

    private createNewWildGlow():PIXI.Sprite {
        const wildGlow:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("WIndividual")[0]);
        wildGlow.blendMode = PIXI.BLEND_MODES.ADD;
        wildGlow.anchor.set(0.5);
        wildGlow.scale.set(2);
        return wildGlow;
    }

    private recycleWildGlow(wildGlow:PIXI.Sprite):void {
        this._wildGlowContainer.removeChild(wildGlow);
        this._wildGlowPool.push(wildGlow);
    }

    private getWinGlow():IndividualWinGlow {
        const winGlow:IndividualWinGlow = this._winGlowPool.length === 0 ? new IndividualWinGlow() : this._winGlowPool.pop()!;
        winGlow.glowSpine.state.clearTrack(0);
        winGlow.glowSpine.skeleton.setToSetupPose();
        winGlow.alpha = 0;

        return winGlow;
    }

    public startWinPresentation():void {
        EventHandler.dispatchEvent(new GameEvent(DWBackground.DIM_REEL, 0.6, 0.2));
    }

    public stopWinPresentation():void {
        this.removeWinText();
        this._winGlowContainer.children.forEach((child:PIXI.DisplayObject) => {
            const winGlow:IndividualWinGlow = <IndividualWinGlow>child;
            TweenLite.to(winGlow, 0.1, {
                alpha : 0, onComplete : () => this.recycleWinGlow(winGlow)
            });
        });
        this._wildGlowContainer.children.forEach((child:PIXI.DisplayObject) => {
            const wildGlow:PIXI.Sprite = <PIXI.Sprite>child;
            TweenLite.to(wildGlow, 0.1, {
                alpha : 0, onComplete : () => this.recycleWildGlow(wildGlow)
            });
        });
        EventHandler.dispatchEvent(new GameEvent(DWBackground.DIM_REEL, 0, 0.1));
    }

    private recycleWinGlow(winGlow:IndividualWinGlow):void {
        this._winGlowContainer.removeChild(winGlow);
        this._winGlowPool.push(winGlow);
        winGlow.glowSpine.state.setEmptyAnimation(0, 0);
    }

    private showWinText(betWayWinData:IBetWayWinData, position:[number, number]):void {
        this.removeWinText();
        this._winNumberText = new WinNumberText(betWayWinData.multipliedAmount, 1, betWayWinData.numberOfCombinations);
        this._winNumberText.position.set(position[0], position[1]);
        this._winNumberText.alpha = 0;
        StageManager.getLayer(DeadwoodGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this._winNumberText);
        this._winNumberTl = TweenLite.to(this._winNumberText, 0.1, {alpha : 1});
    }

    private removeWinText():void {
        if(this._winNumberTl && this._winNumberTl.isActive()) {
            this._winNumberTl.progress(1);
        }
        this._winNumberTl = null;

        if(this._winNumberText) {
            if(this._winNumberText.parent) {
                this._winNumberText.parent.removeChild(this._winNumberText);
            }
            this._winNumberText.destroy();
            this._winNumberText = null;
        }
    }
}